
/**
 * @param {any }value Some value
 * @returns {Boolean}
 */
export function isNil(value: unknown): boolean{
    return typeof value === 'undefined' || value === null || value === 'null' || value === 'undefined'
}